import { useQuery } from '@tanstack/react-query';
import { useContainer } from 'src/features/ioc';
import {
    getRandomSymbolsQuery,
    getSecurityMasterEntriesQuery,
    getSecurityMasterEntryQuery,
    getSymbolsMatchingPrefixQuery,
} from 'src/queries/securityMaster';

export function useSecurityMasterEntry(symbol?: string) {
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    return useQuery(getSecurityMasterEntryQuery(securityMasterService, symbol));
}

export function useSecurityMasterEntries(symbols: string[]) {
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    // todo: https://github.com/yornaath/batshit?tab=readme-ov-file#reactquery-example
    return useQuery(getSecurityMasterEntriesQuery(securityMasterService, symbols));
}

export function useGetSymbolsMatchingPrefix(prefix: string) {
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    return useQuery(getSymbolsMatchingPrefixQuery(securityMasterService, prefix));
}

export function useSymbolEntriesMatchingPrefix(prefix: string) {
    const { data: matchingSymbols = [] } = useGetSymbolsMatchingPrefix(prefix);

    return useSecurityMasterEntries(matchingSymbols);
}

export function useGetRandomSymbols(count: number) {
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    return useQuery(getRandomSymbolsQuery(securityMasterService, count));
}
